<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8 ml-auto mr-auto">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">ParkWhiz Quotes</h4>
            </div>
            <div class="card-body">
            <b-form @submit.prevent="submitForm">

              <b-form-group label="Select Venue" label-for="input-venue">
                <b-form-select
                  id="input-venue"
                  v-model="form.venue"
                  :options="venues"
                  required
                  @change="fetchEvents"
                ></b-form-select>
              </b-form-group>
              <!-- <p>{{form.venue}}</p> -->

              <b-form-group label="Select Event" label-for="input-event">
                <b-form-select
                  id="input-event"
                  v-model="form.event"
                  :options="events"
                  required
                ></b-form-select>
              </b-form-group>
              <!-- <p>{{form.event}}</p> -->
               <br>

              <!-- <b-form-group label="Name" label-for="input-name">
                <b-form-input id="input-name" v-model="form.name" required></b-form-input>
              </b-form-group> -->
  
              <!-- <b-form-group label="Email" label-for="input-email">
                <b-form-input
                  id="input-email"
                  type="email"
                  v-model="form.email"
                  required
                ></b-form-input>
              </b-form-group> -->
  
              <!-- <b-form-group label="Message" label-for="input-message">
                <b-form-textarea
                  id="input-message"
                  v-model="form.message"
                  rows="3"
                  required
                ></b-form-textarea>
              </b-form-group> -->
  
              <!-- <b-form-group label="Reason for Contact" label-for="input-reason">
                <b-form-select
                  id="input-reason"
                  v-model="form.reason"
                  :options="reasons"
                  required
                ></b-form-select>
              </b-form-group> -->

              

              <b-button type="submit" variant="primary" btn-fill @click="fetchQuotes">Get Parking</b-button>
  
              <!-- <b-button type="submit" variant="primary">Submit</b-button> -->
            </b-form>
            </div>
            </div>
        </div>
      </div>

  
      <!-- <b-row class="mt-4">
        <b-col>
          <b-card title="Submitted Data">
            <b-table :items="submissions" :fields="fields" striped hover></b-table>
          </b-card>
        </b-col>
      </b-row> -->

      <div class="row mt-4">
      <!-- Iterate over the API data to display each item in a card -->
      <div class="col-12 col-md-6 col-lg-4 mb-4" v-for="item in quotes" :key="item.location_id">
        <div class="card text-center">
            <img :src="item.image" alt="Card image" class="card-img-top" style="max-height: 200px; object-fit: cover;">
            <div class="card-body">
                <h4 class="card-title">{{ item._embedded['pw:location'].name }}</h4>
                <p class="card-text">
                    <strong>Address:</strong> {{ item._embedded['pw:location'].address1 }}
                </p>
                <p class="card-text">
                <strong>Availability:</strong> {{ item.purchase_options[0].space_availability.status }}
                </p>
                <p class="card-text">
                  <strong>Price:</strong> {{ item.purchase_options[0].price.USD }}
                </p>
                <p class="card-text" v-if="item.purchase_options[0].space_availability.spaces_remaining">
                  <strong>Remaining:</strong> {{ item.purchase_options[0].space_availability.spaces_remaining }}
                </p>
                <p class="card-text">
                  <strong>Distance (miles):</strong> {{ (item.distance.straight_line.meters/1609.34).toFixed(2) }}
                </p>
                <b-button href="#" variant="primary" btn-fill @click="showModal(item)">Reserve</b-button>
            </div>
        </div>
      </div>
    </div>

    <!-- Modal for Editing Details -->
    <b-modal v-model="show" title="Edit Details" @hide="resetForm">
      <b-form @submit.prevent="submitForm">
        <b-form-group label="Quote ID" label-class="font-weight-bold">
          <b-form-input v-model="selected_quote.id" readonly ></b-form-input>
        </b-form-group>
        
        <b-form-group label="Price" label-class="font-weight-bold">
          <b-form-input 
            v-model="selected_quote.price" 
            readonly 
            :class="{'is-valid': isInputValid()}" >
          </b-form-input>
          <!-- <span v-if="isInputValid()" class="checkmark">✔️</span> -->
        </b-form-group>



        <b-form-group label="First Name" label-for="input-first-name" label-class="font-weight-bold">
           <b-form-input id="input-first-name" v-model="booking.firstname" :disabled = "!isInputValid()"></b-form-input>
        </b-form-group>
        <b-form-group label="Last Name" label-for="input-last-name" label-class="font-weight-bold">
           <b-form-input id="input-last-name" v-model="booking.lastname" :disabled = "!isInputValid()"></b-form-input>
        </b-form-group>

        <b-form-group label="Email" label-for="input-email" label-class="font-weight-bold">
           <b-form-input
              id="input-email"
              type="email"
               v-model="booking.email"
              required
              disabled
             ></b-form-input>
        </b-form-group>

        <b-form-group label="Response" label-for="textarea" label-class="font-weight-bold">
          <b-form-textarea
              id="textarea"
              v-model="response"
              placeholder=""
              rows="3"
              max-rows="8"
              plaintext
          ></b-form-textarea>
        </b-form-group>

        <b-form-group label="Parking Pass Link" label-for="input-pass-link" label-class="font-weight-bold">
           <b-form-input id="input-pass-link" v-model="booking.url" readonly ></b-form-input>
        </b-form-group>

        <b-input-group-append>
          <b-button @click="copyToClipboard" variant="outline-secondary">
            <b-icon icon="clipboard"></b-icon>
          </b-button>
        </b-input-group-append>
        <b-alert :show="copySuccess" variant="success">Link Copied to Clipboard</b-alert>

        <!-- <b-alert v-if="copySuccess" variant="success" dismissible>
          Text copied to clipboard!
        </b-alert> -->

        
       

        <div class="d-flex justify-content-center mt-3">
          <b-button type="submit" class="mx-2" variant="success" @click="fetchPreview">Confirm Quote</b-button> 
          <!-- Purchase Button -->
          <b-button 
            type="submit" 
            class="mx-2"
            variant="success" 
            :disabled = "!isInputValid()"
            @click = "postBooking">Purchase</b-button> 
          <b-button variant="secondary" @click="show = false" class="mx-2">Cancel</b-button>
        </div>
      </b-form>
    </b-modal>
    <!-- Feedback message -->
    
</div>
  </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: '',
          email: '',
          message: '',
          reason: null,
          venue: null,
          event: null
        },
        reasons: [
          { value: null, text: 'Please select an option' },
          { value: 'support', text: 'Support' },
          { value: 'sales', text: 'Sales' },
          { value: 'feedback', text: 'Feedback' },
          { value: 'other', text: 'Other' },
        ],
        venues: [],
        events:[],
        quotes:[],
        response:[],
        textToCopy: '', // The text inside the input box
        copySuccess: false, // Feedback message visibility
        selected_quote:{
          id:'',
          price: null,
          confirmed: false
        },
        booking:{
          firstname:'Nick',
          lastname:'Huey',
          email:'dev@tcntix.com',
          saved_payment_token:'g26f5dry',
          send_email_confirmation: true,
          final_price:null,
          fields: 'booking::default,booking:parking_pass_web_url,booking:authorization_code',
          url:null
        },
        submissions: [], // Array to store the submitted data
        // venues:[], // Array to store the venues
        show: false,  // Control thei visability of the modal form
        fields: [
          { key: 'name', label: 'Name' },
          { key: 'email', label: 'Email' },
          { key: 'message', label: 'Message' },
          { key: 'reason', label: 'Reason for Contact' },
        ],
      };
    },
    computed: {
    isFormValid() {
      return this.selected_quote.confirmed;
    }},
    methods: {
      async submitForm() {
        try {
          // const response = await this.$http.post('https://api.spotjockeys.com/api/form', this.form);
          // this.submissions.push(response.data); // Add the new submission to the array
          this.form.name = '';
          this.form.email = '';
          this.form.message = '';
          this.form.reason = null;
          // alert('Form submitted successfully!');
        } catch (error) {
          console.error('Error submitting form:', error);
          alert('There was an error submitting the form.');
        }
      },
      async fetchSubmissions(){
        try {
        const response = await this.$http.get('https://api.spotjockeys.com/api/submissions');
        this.submissions = response.data;
      } catch (error) {
        console.error('Error fetching submissions:', error);
      }
    },
    //Lists the venues based off of our listing in the venues table
      async fetchVenues(){
        try {
        const response = await this.$http.get('https://api.spotjockeys.com/api/venues');
        this.venues = response.data.map(item => ({
          value: item.pw_venue_id,
          text: item.name,
        }));
        console.log(this.venues)
      } catch (error) {
        console.error('Error fetching venues:', error);
      }
    },
    //List the events for the given venue
    async fetchEvents(){
        try {
        const response = await this.$http.get('https://api.spotjockeys.com/api/events',{ 
          params: { 
                  venue_id:this.form.venue
                  }
                }
        );
        
        this.events = response.data.map(item => ({
          value: item.id,
          text: item.name,
        }));
        console.log(this.venues)
      } catch (error) {
        console.error('Error fetching venues:', error);
      }
    },
    //Search Quotes for a venue and event
    async fetchQuotes(){
        try {
        const response = await this.$http.get('https://api.spotjockeys.com/api/quotes',{ 
          params: { 
                  venue_id:this.form.venue,
                  event_id:this.form.event
                  }
                }
        );
                
        this.quotes = response.data;

        console.log(this.quotes)
      } catch (error) {
        console.error('Error fetching venues:', error);
      }
    },
    //Preview Pass Information (required before purchase, this validates the price)
    async fetchPreview(){
        console.log('quote_id:',this.selected_quote.id)
        try {
        const response = await this.$http.post('https://api.spotjockeys.com/api/preview',{ 
          'quote_id':this.selected_quote.id
        });
        
        
        this.response = response.data;

        // console.log(this.response)
        console.log('Final Price:', parseFloat(this.response.final_price.USD))
        console.log('Selected Price:', parseFloat(this.selected_quote.price))

        if (parseFloat(this.selected_quote.price) == parseFloat(this.response.final_price.USD)) {
          this.selected_quote.confirmed = true
          this.booking.final_price = this.selected_quote.price
          console.log('Price Confirmed')
        }
        
        
      } catch (error) {
        console.error('Error fetching venues:', error);
      }
    },
    //Purchase Pass
    async postBooking(){
        console.log('quote_id:',this.selected_quote.id)
        try {
        const response = await this.$http.post('https://api.spotjockeys.com/api/booking',{ 
          'quote_id':this.selected_quote.id,
          'final_price':this.booking.final_price,
          'customer_firstname':this.booking.firstname,
          'customer_lastname':this.booking.lastname,
          'customer_email': this.booking.email,
          'send_email_confirmation': this.booking.send_email_confirmation,
          'saved_payment_token': this.booking.saved_payment_token,
          'fields': this.booking.fields
        });
        
        this.response = response.data;
        this.booking.url = response['parking_pass_web_url']

        console.log(response.data)
        // console.log('Final Price:', parseFloat(this.response.final_price.USD))
        // console.log('Selected Price:', parseFloat(this.selected_quote.price))
        
      } catch (error) {
        console.error('Error Posting Booking:', error);
      }
    },
    isInputValid() {
      // return input.length > 0; // Simple validation to check if input is not empty
            return this.selected_quote.confirmed
    },
    showModal(item) {
      // Set form data based on the selected item and show the modal
      this.selected_quote.id = item.purchase_options[0].id;
      this.selected_quote.price = item.purchase_options[0].price.USD
      this.selected_quote.confirmed = false
      this.show = true;
    },
    resetForm() {
      // Reset form data when the modal is closed
      // this.formData = {
      //   lotname: '',
      //   availability: '',
      //   price: null,
      // };
    },
    async copyToClipboard() {
      try {
        // Use the modern Clipboard API
        this.copySuccess = true; // Show success message
        await navigator.clipboard.writeText(this.booking.url);
        
        setTimeout(() => (this.copySuccess = false), 2000); // Hide after 2 seconds
      } catch (err) {
        console.error('Failed to copy text', err);
      }
    },
  },
  mounted(){
    this.fetchSubmissions();
    this.fetchVenues();
  }

  };
  </script>

<style scoped>
/* Style for the checkmark inside the input field */
.position-relative {
  position: relative;
}

.checkmark {
  position: absolute;
  right: 20px;
  top: 33%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: green;
  pointer-events: none;
}

/* Optionally, you can customize the styles for valid and invalid states */
.is-valid {
  border-color: #28a745 !important;
}

.is-invalid {
  border-color: #dc3545 !important;
}
</style>
  